export default __webpack_public_path__ + "static/media/home_page.35f4cbd3.png";